// src/pages/categories/CategoryForm.js
import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/config';

export default function CategoryForm({ category, onSuccess, onCancel }) {
  const [name, setName] = useState(category?.name || '');
  const token = localStorage.getItem('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (category) {
        await axios.put(`${API_BASE_URL}/api/categories/${category.id}`, { name }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(`${API_BASE_URL}/api/categories`, { name }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      onSuccess();
    } catch (err) {
      console.error('Error saving category:', err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Category name"
        className="border px-3 py-2 mr-2 rounded"
        required
      />
      <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
        {category ? 'Update' : 'Add'}
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="ml-2 text-gray-600 underline"
      >
        Cancel
      </button>
    </form>
  );
}
